import { render, staticRenderFns } from "./tprDeliveryPriceDetail.vue?vue&type=template&id=2b612bd1&"
import script from "./tprDeliveryPriceDetail.vue?vue&type=script&lang=js&"
export * from "./tprDeliveryPriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./tprDeliveryPriceDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports